import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Rating from "react-rating-stars-component";
import UserNav from "./UserNav";
import { Row, Col, Button, Spinner,Form } from 'react-bootstrap';

const UsersSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [testID, setTestId] = useState(null);
  const [rating, setRating] = useState(0);
  const [checkboxOptions, setCheckboxOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]); // Initialize as an empty array
  const [feedback, setFeedback] = useState("");
  const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);
  const [respError, setRespError] = useState("");
  const [infoMessage, setInfoMessage] = useState(""); // Add state for info message
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    setTestId(id);
  }, [location.search]);

  const ratingChanged = (newRating) => {
    setRating(newRating);
    setShowFeedbackDialog(true);
    let options;
    if (newRating <= 3) {
      options = ["The test was too difficult.",
                 "Instructions were unclear.", "The test did not cover the topics I studied.",
                  "I need more practice on the subjects."];
    } else {
      options = ["The test was well-structured.",
        "The difficulty level was appropriate.",
        "The test covered all the important topics.",
        "I felt well-prepared for the test."];
    }
    setCheckboxOptions(options);
    setSelectedOptions([]); // Reset selectedOptions when rating changes
  };

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option) ? prev.filter((o) => o !== option) : [...prev, option]
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      test_id: testID,
      rating: rating.toString(), // Convert rating to string before sending
      selectedOptions: selectedOptions,
      feedback: feedback
    };

    try {
      const response = await fetch('https://l2wp8df1a2.execute-api.us-east-2.amazonaws.com/prod/candidate_get_feedback', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.status === 200) {
        setLoading(false);
        // Assuming the API returns an 'info' message on successful submission
        setInfoMessage(responseData.info); 
        setShowFeedbackDialog(false); // Optionally, hide the feedback dialog
      } else {
        setLoading(false);
        throw new Error(responseData.info || 'Failed to submit feedback');
      }
    } catch (error) {
      setLoading(false);
      setRespError(error.message);
    }
  };

  return (
    <>
      <UserNav />
      <div className="user-thanks-div">
        <div className="question-div" style={{padding:'8px'}}>
          <h1 className="end-test">Thank you for taking the test, you will receive the score card via registered Email</h1>
          <h2 className="end-test">Submit Feedback</h2>
          <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
            <Rating count={5} onChange={ratingChanged} size={60} activeColor="#ffd700" />
          </div>
          {showFeedbackDialog && (
            <div style={{ marginTop: "20px" }}>
              {checkboxOptions.map((option, index) => (
                <div key={index}>
                  <input
                    type="checkbox"
                    id={option}
                    name={option}
                    value={option}
                    onChange={() => handleCheckboxChange(option)}
                    checked={selectedOptions.includes(option)}
                    style={{marginRight:'8px'}}
                  />
                  <label htmlFor={option}>{option}</label>
                </div>
              ))}
              <div style={{ marginTop: "10px" }}>
                <label htmlFor="feedback">Feedback:</label>
                <textarea
                  id="feedback"
                  name="feedback"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  rows="4"
                  style={{ display: "block", width: "100%",marginBottom:'10px' }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Button onClick={handleSubmit} style={{ 
                  backgroundColor: "#4CAF50", 
                  color: "white", 
                  padding: "10px", 
                  border: "none", 
                  borderRadius: "5px", 
                  cursor: "pointer", 
                  fontSize: "16px" 
                }}>
                  Submit
                </Button>
              </div>
              {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
              {/* Your component content */}
              {infoMessage && <div style={{ color: "green", marginTop: "20px" }}>{infoMessage}</div>}
              {respError && <div style={{ color: "red", marginTop: "20px" }}>{respError}</div>}
              {/* The rest of your component JSX */}

            </div>
          )}
        </div>
      </div>
      <footer className="footer-div">
        <p style={{ color: "white" }}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
    </>
  );
};

export default UsersSummary;
